import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserAuthService {

  constructor(private $http: HttpClient,
    @Inject('env') private $env) { }

  /**
   * Method to login 
   * @param username String username
   * @param password String password
   * @return observable
   */
  login(username, password): Observable<any>{
    let credential: any={
      username: username,
      password: password
    }; 
    return this.$http.post(this.$env.API_EP + '/login', credential);
  }

  /**
   * Method customer login
   * @param email     customer email/phone
   * @param password  password
   * @return observable
   */
  portalLogin(email, password): Observable<any>{
    let credential: any = {
      username: email,
      password: password
    };
    return this.$http.post(this.$env.API_EP + '/customer-login', credential);
  }

  changePassword(oldPwd, newPwd): Observable<any>{
    let credential: any = {
      old_password: oldPwd,
      new_password: newPwd
    };
    return this.$http.post(this.$env.API_EP + '/change-password', credential);
  }

  logout(): Observable<any>{
    return this.$http.post(this.$env.API_EP + '/logout', {});
  }
}
